<template>
    <div class="modal-content land-flat-modal-content">
        <button class="btn-close-flat-card--modal" @click="closeFlatModal()"><svg-icon icon-class="close" className="icon-close"/></button>
        <div class="col-left" :class="{active: resizeCardImg}">
            <div class="btn-resize" :class="{active: resizeCardImg}" @click="resizeModalCardImg">
                <svg-icon icon-class="inresize" className="icon-inresize"/>
                <svg-icon icon-class="unresize" className="icon-unresize"/>
            </div>
            <div class="flat-card-big-img">
                <img :src="modalData.flat_img" alt="">
            </div>
            <div class="flat-card-info-images">
                <div class="col">
                    <img :src="modalData.rose" alt="">
                </div>
                <div class="col">
                    <!-- <img :src="'data:image/' + modalData.flats_card_modal.plan.pictureformat + '+xml;base64,' + modalData.flats_card_modal.plan.binary" alt=""> -->
                </div>
            </div>
        </div>
        <div class="col-right">
            <div class="flat-card-top-info">
                <div class="info-item">
                    <h3>Квартира <span>{{modalData.room}}{{modalData.type}}</span></h3>
                </div>
                <div class="info-item">
                    <div class="item">
                        <div class="in">
                            <p>{{flats.land_flats_cards_info.size}} -</p>
                            <strong>{{modalData.size}}<span>м²</span></strong>
                        </div>
                    </div>
                    <div class="item" style="display: inline-block; margin-right: 20px;">
                        <div class="in">
                            <p>Этаж -</p>
                            <strong>{{modalData.floor}}</strong>
                        </div>
                    </div>
                    <div class="item" style="display: inline-block">
                        <div class="in">
                            <p>Пятно -</p>
                            <strong>{{modalData.block}}</strong>
                        </div>
                    </div>
                    <!-- <div class="item" v-if="salesCard.project_stie_shablon_price_flats_init != 'false'">
                        <div class="in">
                            <p>Цена -</p>
                            <strong><span class="start">от </span>{{modalData.flats_card_price_min.slice(0,3)}} 000<span class="wollet">₸</span><span> за м²</span></strong>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="flat-card-btns-container">
                <div class="flat-btn-print">
                    <a :href="modalData.pdf" donwload target="_blank" class="btn-print">
                        <svg-icon icon-class="print" className="icon-print"/>
                        <p v-if="!this.config[0].mobile">{{flats.land_flats_cards_info.flat_btn_print_name}}</p>
                        <p v-else>{{flats.land_flats_cards_info.flat_btn_print_name_mobile}}</p>
                    </a>
                </div>
                <div class="flat-btn-mail">
                    <a href="#" class="btn-mail" @click.prevent="InputMailInit"  v-if="!formActive"> 
                        <svg-icon icon-class="mail" className="icon-mail"/>
                        <p>{{flats.land_flats_cards_info.flat_btn_mail_name}}</p>
                    </a>
                    <transition name="fade">
                        <formMail v-if="formActive"
                                :options="[{pdf: modalData.pdf, name: modalData.room + modalData.type + '-x ком. квартира ' +  modalData.size + 'м²' + ' в ' + CapitalizeID(project) + '.pdf'}]"
                        ></formMail>
                    </transition>
                </div>
                <div class="flat-social-share-btns">
                    <div class="flats-social-share-title">
                        <h4>{{flats.land_flats_cards_info.flat_btn_social_title}}</h4>
                    </div>
                    <button class="button btn-share-flat-to-social btn-share-flat-to-social-desctop" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.room + modalData.type + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.size + ' м²' + ' в ' + project" :data-url="modalData.pdf" data-web><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
                    <button class="button btn-share-flat-to-social btn-share-flat-to-social-mobile" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.room + modalData.type + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.size + ' м²' + ' в ' + project" :data-url="modalData.pdf"><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="telegram" :data-title="'Ваша' + ' ' + modalData.room + modalData.type + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.size + ' м²' + ' в ' + project" :data-url="modalData.pdf"><svg-icon icon-class="telegram" className="flat-share-icon icon-telegram"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="facebook" :data-hashtag="'МояКвартира_в_' + project" :data-url="modalData.pdf"><svg-icon icon-class="facebook-flat" className="flat-share-icon icon-facebook"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="vk" :data-title="'Ваша' + ' ' + modalData.room + modalData.type + ' ' + flats.land_flats_cards_info.flat_modal_title + ' ' +  modalData.size + ' м²' + ' в ' + project" :data-url="modalData.pdf"><svg-icon icon-class="vk-flat" className="flat-share-icon icon-vk"/></button>
                </div>
            </div>
            <div class="flat-card-form">
                <div class="flat-card-form-titles">
                    <h3>{{form.form_sales_land_flat_title}}</h3>
                    <p>{{form.form_sales_land_flat_desc}}</p>
                </div>
                <formFields class="form-flats-card-setup"></formFields>
            </div>
        </div>
    </div>
</template>

<script>
	import formFields from '@/components/forms/form-flat.vue';
	import formMail from '@/components/forms/form-mail.vue';	
    import {mapGetters} from 'vuex'
	export default {
        name: 'flat-modal',
        props: ['config'],
		components: {
			formFields,
			formMail,
		},
		data () {
			return {
                formActive: this.config[0].active,
                resizeCardImg: false,
                project: window.host,
			}
        },
        computed: mapGetters({
            form: 'loadForms',
            flats: 'loadSalesCardPage',
			modalData: 'loadSalesLandModalDataArr',
            salesCard: 'loadSalesCardContent',
        }),
		// computed: {
		// 	flats () {
		// 		return this.$store.state.flats
		// 	},
		// 	form () {
		// 		return this.$store.state.forms
		// 	},
		// 	modalData() {
        //         return this.$store.state.modalData
		// 	},
		// },
		methods: {
			closeFlatModal() {
				this.$modal.hide('sales_land_flat-card-modal');
            },
            InputMailInit() {
				this.formActive = true;
            },
            resizeModalCardImg() {
				this.resizeCardImg = !this.resizeCardImg;
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
		},
		mounted() {
			// this.$store.watch(
			// 	(state) => state.flatCards,
			// 	(newValue) => {
			// 		if (newValue.length >= 4) {
			// 		}
			// 	}
			// )
		}
	}
</script>

<style lang="scss" scoped>
    @import '@/styles/components/sales/sales-land-partials/land-flats-modal.scss';
    @import '@/styles/respond/sales/sales-land-partials/flats-partials/flat-modal-respond.scss';
    @import '@/styles/components/forms/form-flat.scss';

	// @import '@/styles/components/flats/modal.scss';
    // @import '@/styles/components/forms/form-flat.scss';
    // @import '@/styles/components/flats/flats-respond/modal-respond.scss';
    // @import '@/styles/components/forms/forms-respond/form-flat-respond.scss';
	// @import '@/styles/components/animation/animation-flat.scss';
</style>